/**
 * @generated SignedSource<<ff9c46976a0d4e449e2a1b46064faac4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CustomFieldType = "FREE_TEXT" | "DROPDOWN" | "%future added value";
export type CreateTicketingCustomFieldDefinitionInput = {
  name: string;
  key: string;
  fieldType: CustomFieldType;
  options?: ReadonlyArray<string> | null;
  readOnly?: boolean | null;
  requiredOnResolution?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type useCreateCustomFieldDefinitionMutation$variables = {
  input: CreateTicketingCustomFieldDefinitionInput;
};
export type useCreateCustomFieldDefinitionMutation$data = {
  readonly createTicketingCustomFieldDefinition: {
    readonly clientMutationId: string | null;
    readonly customFieldDefinitionEdge: {
      readonly cursor: string;
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly key: string;
        readonly fieldType: CustomFieldType;
        readonly options: ReadonlyArray<string> | null;
        readonly readOnly: boolean;
        readonly requiredOnResolution: boolean;
      } | null;
    } | null;
  } | null;
};
export type useCreateCustomFieldDefinitionMutation = {
  variables: useCreateCustomFieldDefinitionMutation$variables;
  response: useCreateCustomFieldDefinitionMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateTicketingCustomFieldDefinitionPayload",
    "kind": "LinkedField",
    "name": "createTicketingCustomFieldDefinition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TicketingCustomFieldDefinitionTypeEdge",
        "kind": "LinkedField",
        "name": "customFieldDefinitionEdge",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TicketingCustomFieldDefinition",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fieldType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "options",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "readOnly",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requiredOnResolution",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCreateCustomFieldDefinitionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCreateCustomFieldDefinitionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c1b378cab37cc2ace5dc6a24d06904f6",
    "id": null,
    "metadata": {},
    "name": "useCreateCustomFieldDefinitionMutation",
    "operationKind": "mutation",
    "text": "mutation useCreateCustomFieldDefinitionMutation(\n  $input: CreateTicketingCustomFieldDefinitionInput!\n) {\n  createTicketingCustomFieldDefinition(input: $input) {\n    clientMutationId\n    customFieldDefinitionEdge {\n      cursor\n      node {\n        id\n        name\n        key\n        fieldType\n        options\n        readOnly\n        requiredOnResolution\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "16bb1bf44b5bdc4650386733073ac925";

export default node;
